import type { IntlShape } from 'react-intl';
import type { ConfirmOptions } from '../../components/confirmContext';
import type { DeliverableGap } from './deliverableTexts';
import { TranslationGapList } from './TranslationGapList';

/**
 * Before writing a deliverable: when texts go in as their originals although
 * they are not German, list them — each linked to its record — and ask whether
 * to export anyway. Only a warning: a delivery must never hang on a missing
 * acceptance. True when there is no gap or the user goes ahead.
 */
export function confirmTranslationGaps(
    confirm: (options: ConfirmOptions) => Promise<boolean>,
    intl: IntlShape,
    gaps: readonly DeliverableGap[]
): Promise<boolean> {
    if (gaps.length === 0) {
        return Promise.resolve(true);
    }
    return confirm({
        title: intl.formatMessage({ id: 'export.translationGaps.title' }),
        message: intl.formatMessage(
            { id: 'export.translationGaps.message' },
            { count: gaps.length }
        ),
        details: <TranslationGapList gaps={gaps} />,
        confirmLabel: intl.formatMessage({
            id: 'export.translationGaps.confirm'
        })
    });
}
